import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, Database, GameController, PlayCircle, ChartLineUp, Swap } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { Card, BarSeries } from "./adminUi";

const CONTENT_LABELS = {
    challenges: "Challenges",
    generations: "Generace sestav",
    lineup_sims: "Lineup simulace",
    season_sim_runs: "Simulace sezóny",
    inko_games: "INKO hry",
    market_decisions: "Market rozhodnutí",
    transfers_tracked: "Sledované přestupy",
    analytics_events: "Analytics eventy",
};

export default function AdminOverview() {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = async () => {
        setBusy(true);
        try {
            const r = await api.get("/admin/overview", { params: { days: 30 } }).then((r) => r.data);
            setData(r);
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Nepodařilo se načíst přehled");
        } finally {
            setBusy(false);
        }
    };

    useEffect(() => { load(); }, []);

    if (!data) {
        return <div className="font-mono text-[11px] text-white/50 p-4">{busy ? "Načítám…" : "Žádná data"}</div>;
    }

    const u = data.users || {};
    const content = data.content || {};

    return (
        <div className="space-y-6" data-testid="admin-overview">
            <section className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <Card label="Uživatelů celkem" value={u.total?.toLocaleString("cs") ?? "—"} icon={Users} accent="text-fa-sky" testid="ov-users-total" />
                <Card label="Noví za 7 dní" value={u.new_7d ?? "—"} icon={Users} accent="text-fa-mint" testid="ov-users-7d" />
                <Card label="Noví za 30 dní" value={u.new_30d ?? "—"} icon={Users} accent="text-fa-yellow" testid="ov-users-30d" />
                <Card label="Simulací sezóny" value={content.season_sim_runs ?? "—"} icon={PlayCircle} accent="text-white" testid="ov-sim-runs" />
            </section>

            <BarSeries
                title="Registrace za posledních 30 dní"
                rows={(data.registrations_daily || []).map((d) => ({ date: d.date, count: d.count }))}
                colorClass="bg-fa-sky/80"
                testid="ov-registrations"
            />

            <section className="border border-white/10 bg-[#0d0d0d] p-4 space-y-2" data-testid="ov-content">
                <h3 className="font-display font-black uppercase tracking-tight text-sm flex items-center gap-2">
                    <Database size={12} weight="fill" className="text-fa-mint" />
                    Obsah platformy
                </h3>
                <ul className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    {Object.entries(content).map(([k, v]) => (
                        <li key={k} className="flex items-center justify-between border border-white/10 bg-black/40 px-2 py-1.5">
                            <span className="font-mono text-[10px] uppercase tracking-widest text-white/60">{CONTENT_LABELS[k] || k}</span>
                            <span className="font-mono text-[11px] tabular-nums text-white">{v?.toLocaleString("cs")}</span>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
}
